import { EntityModel } from '@/interfaces'
import {
  ALL_ONLINE_PAYMENT_CONFIGS_QUERY,
  CREATE_ONLINE_PAYMENT_CONFIG_MUTATION,
  DELETE_ONLINE_PAYMENT_CONFIG_MUTATION,
  FORCE_DELETE_ONLINE_PAYMENT_CONFIG_MUTATION,
  SINGLE_ONLINE_PAYMENT_CONFIG_QUERY,
  UPDATE_ONLINE_PAYMENT_CONFIG_MUTATION,
} from './graphql'

const tenantOnlinePaymentConfigModel: EntityModel = {
  name: 'onlinePaymentConfig',
  namePlural: 'onlinePaymentConfigs',
  uniqueName: 'tenantOnlinePaymentConfig',
  uniqueNamePlural: 'tenantOnlinePaymentConfigs',
  path: 'config/tenant/online_payment_config',
  baseUrl: '/config/tenant/online_payment_configs',
  translationPrefix: 'entities:tenantOnlinePaymentConfig.',
  getDisplayName: (values: any) => {
    return 'ONLINE PAYMENT CONFIG'
  },
  gql: {
    getAll: ALL_ONLINE_PAYMENT_CONFIGS_QUERY,
    getSingle: SINGLE_ONLINE_PAYMENT_CONFIG_QUERY,
    create: CREATE_ONLINE_PAYMENT_CONFIG_MUTATION,
    update: UPDATE_ONLINE_PAYMENT_CONFIG_MUTATION,
    delete: DELETE_ONLINE_PAYMENT_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_ONLINE_PAYMENT_CONFIG_MUTATION,
  },
  attributes: {
    enabled: {
      name: 'enabled',
      label: 'entities:tenantOnlinePaymentConfig.attributes.enabled.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    ratioFibuAccountNo: {
      name: 'ratioFibuAccountNo',
      label: 'entities:tenantOnlinePaymentConfig.attributes.ratioFibuAccountNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    infoText: {
      name: 'infoText',
      label: 'entities:tenantOnlinePaymentConfig.attributes.infoText.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
    datatransThemeConfig: {
      name: 'datatransThemeConfig',
      label: 'entities:tenantOnlinePaymentConfig.attributes.datatransThemeConfig.label',
      type: 'value',
      dataType: '{ [x: string]: any }',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
  },
}

export default tenantOnlinePaymentConfigModel
